// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"vp-z","slideIn":"wp-z"};